import { resolveAssetUrl } from './api';
export function mapLibraryObjectResponses(items, _userId, _movieId) {
    return items.map((item) => {
        const src = item.url
            ? resolveAssetUrl(item.url)
            : item.fullPath
                ? resolveAssetUrl(item.fullPath)
                : '';
        const thumbnail = item.thumbnailUrl
            ? resolveAssetUrl(item.thumbnailUrl)
            : undefined;
        return {
            id: String(item.id),
            name: item.name,
            type: item.type,
            src,
            thumbnail,
        };
    });
}
